import { Injectable } from "@angular/core";
import { RestService } from "src/app/Services/Rest/rest.service";
import { login_body, getOTP_body } from "src/app/common";
import {
  commonConstants,
  RoutesAll,
  Cookies,
  lender,
} from "src/app/Constants/app.constants";
import { Router } from "@angular/router";
import { HttpHeaders } from "@angular/common/http";
import { KeycloakService } from "keycloak-angular";

export class User {
  constructor(
    public email?: any | null,
    public password?: any | null,
    public isAgreedTerms?: any | null,
  ) {}
}

export class AddCustomer {
  constructor(
    public email?: any | null,
    public userName?: any | null,
    public GSTIN?: any | null,
    public fromDate?: Date | null,
    public isAgreedConsent?: boolean | null,
    public toDate?: Date | null
  ) {}
}

export class AddMail {
  constructor(public toEmail: string, public ccEmail: string) {}
}

@Injectable()
export class AuthenticationService {

  ErrorDetailsDialogData : any;
  UploadPdfpageDialogData : any;
  openUploadFileModalDialogData : any;
  closeUploadFileModalDialogData : any;
  constructor(
    private restService: RestService,
    private router: Router,
    protected keycloakAngular: KeycloakService
  ) {}

  isTokenValid() {
    let body = {
      user_id: localStorage.getItem("userId"),
      api_auth_token: this.keycloakAngular.getKeycloakInstance().idToken,
    };

    this.restService.isTokenValid(body, (data: any) => {
      if (!data) {
        // location.reload()
        /**
         * comment due to auto realod page issue
         */
      }
    });
  }

  login(user: any, cb: any) {
    let authenticatedUserToken = "";
    let uid = "";
    let unread_notification_count = "";
    let first_name = "";
    login_body["user-id"] = user.email;
    login_body["password"] = user.password;

    this.restService.postRestLoginCall(login_body, (data: any) => {
      if (data && data.data && data.data.api_auth_token) {
        authenticatedUserToken = data.data.api_auth_token;
        uid = data.data.user_id;
        unread_notification_count = data.data.unread_notification_count;
        this.setCookies(Cookies.userId, uid, 7);
        this.setCookies(Cookies.apiToken, authenticatedUserToken, 7);
        this.setCookies(Cookies.userId, uid, 7);
        this.setCookies(Cookies.apiToken, authenticatedUserToken, 7);
        if (data.data.first_name) {
          this.setCookies(Cookies.userName, data.data.first_name, 7);
        }
        if (data.data.corporateName) {
          this.setCookies(Cookies.corporateName, data.data.corporateName, 7);
        }
        if (data.data.displayName) {
          this.setCookies(Cookies.displayName, data.data.displayName, 7);
        }
        if (data.data.corporateId) {
          this.setCookies(Cookies.corporateId, data.data.corporateId, 7);
        }
        cb(data);
      } else {
        cb(data);
      }
    });
  }

  getGSTINData(reuqestBody: any, requestURL: any, cb: any) {
    let apiAuthToken = this.getCookies(Cookies.apiToken);

    let customHttpHeader = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "client-security-token": apiAuthToken,
      }),
    };

    this.restService.postRestCall(
      reuqestBody,
      requestURL,
      (data: any) => {
        cb(data);
      },
      customHttpHeader
    );
  }

  getOrderData(cb: any) {
    let customHttpHeader = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    this.restService.postRestCall(
      cb,
      "http://64.225.116.40:8080/gstin/rest/customer/getMaster/REPORT",
      (data: any) => {
        cb(data);
      },
      customHttpHeader
    );
  }

  setCookies(cname: any, cvalue: any, exdays: any) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  getCookies(cname: any) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  // logout() {
  //   this.setCookies(Cookies.userId, "", 0);
  //   this.setCookies(Cookies.apiToken, "", 0);
  //   this.setCookies(Cookies.userEmailAddress, "", 0);
  //   this.setCookies(Cookies.gstEmailAddress, "", 0);
  //   this.setCookies(Cookies.gstusername, "", 0);
  //   this.setCookies(Cookies.gstin, "", 0);
  //   this.setCookies(Cookies.userName, "", 0);
  //   this.setCookies(Cookies.displayName, "", 0);
  //   this.setCookies(Cookies.corporateId, "", 0);
  //   this.setCookies(Cookies.fromDate, "", null);
  //   this.setCookies(Cookies.toDate, "", null);
  //   this.setCookies(Cookies.lenderEmail, "", 0);
  //   // this.router.navigate([RoutesAll.authLogin]);

  //   let refereceNo = localStorage.getItem("referenceNo");
  //   let userId = localStorage.getItem("userId");
  //   let logout_body = {
  //     request: "web/logout",
  //     para: {
  //       term_reference_no: refereceNo,
  //       user_id: userId,
  //     },
  //   };

  //   this.restService.postRestAPICall(logout_body, (data: any) => {});

  //   this.keycloakAngular.getKeycloakInstance().logout();
  // }


  logout() {
    let idToken = this.keycloakAngular.getKeycloakInstance().idToken;
    this.setCookies(Cookies.userId, "", 0);
    this.setCookies(Cookies.apiToken, "", 0);
    this.setCookies(Cookies.userEmailAddress, "", 0);
    this.setCookies(Cookies.gstEmailAddress, "", 0);
    this.setCookies(Cookies.gstusername, "", 0);
    this.setCookies(Cookies.gstin, "", 0);
    this.setCookies(Cookies.userName, "", 0);
    this.setCookies(Cookies.displayName, "", 0);
    this.setCookies(Cookies.corporateId, "", 0);
    this.setCookies(Cookies.fromDate, "", null);
    this.setCookies(Cookies.toDate, "", null);
    this.setCookies(Cookies.lenderEmail, "", 0);
    // this.router.navigate([RoutesAll.authLogin]);
    let refereceNo = localStorage.getItem("referenceNo");
    let userId = localStorage.getItem("userId");
    let logout_body = {
      request: "web/logout",
      para: {
        term_reference_no: refereceNo,
        user_id: userId,
      },
    };
    this.restService.postRestAPICall(logout_body, (data: any) => {});
    // this.keycloakAngular.getKeycloakInstance().logout();
    this.buildLogoutURLAndRedirect(idToken);
    this.keycloakAngular.clearToken();
  }
 
  buildLogoutURLAndRedirect(idToken) {
    // let redirectUri = window.location.origin + "/home";
    // let realm = this.keycloakAngular.getKeycloakInstance().realm;
    // let logoutRouteURL =
    //   this.keycloakAngular.getKeycloakInstance().authServerUrl +
    //   "/realms/corpository/protocol/openid-connect" +
    //   "/logout?client_id=gstin&post_logout_url=" +
    //   redirectUri +
    //   "&id_token_hint=" +
    //   idToken;
    //   // this.keycloakAngular.logout(logoutRouteURL);
    //   let logoutRouteURL1 =
    //   this.keycloakAngular.getKeycloakInstance().authServerUrl +
    //   "/realms/corpository/protocol/openid-connect" +
    //   "/logout"
    // let customHttpHeader = {
    //   headers: new HttpHeaders({
    //     "Content-Type": "application/x-www-form-urlencoded",
    //     "Authorization":idToken
    //   }),
    // };
    // let body = {
    //   "client_id": "gstin",
    //   "post_logout_url": "http://localhost:4200/home",
    //   "id_token_hint": idToken
    // };

    this.keycloakAngular.getKeycloakInstance().logout();
    // this.restService.postRestCallClient(body, logoutRouteURL, (data: any) => {
    //   if (data) {
    //     // window.location.href = window.location.origin + '/assets/keycloak/silent-check-sso.html'
    //   }
    // }, customHttpHeader);
    // window.location.href = logoutRouteURL;
  }


  redirectToHomePage() {
    this.router.navigate([RoutesAll.lender]);
  }

  redirectToAddCustomer() {
    this.setCookies(Cookies.fromDate, "", null);
    this.setCookies(Cookies.toDate, "", null);
    this.router.navigate([RoutesAll.authAddCustomer]);
  }

  redirectToAddOrder() {
    this.router.navigate([]).then((result) => {
      window.open(RoutesAll.getconsent);
    });
  }
}
